import { useSafeFocusEffect } from '@sg/garnish';
import { useOtaMachine, useOtaMachineObserver } from '@sg/ota-installer';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useGlobalAppState } from '../../context/GlobalAppState';
import { otaLogger } from '../../context/OTA';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Initializes an OTA update machine observer.
 */
export const useStartOtaObserver = () => {
  const { otaMachineRef } = useGlobalAppState();

  const isOtaInstallerEnabled = useFeatureFlag('CELS-4466-order-in-app-ota-install-enabled', {
    listenForChanges: true,
  });

  useOtaMachineObserver({
    isEnabled: isOtaInstallerEnabled,
    actorRef: otaMachineRef,
    logger: otaLogger,
  });
};

/**
 * Applies OTA update (if available) on screen focus.
 */
export const useOtaOnScreenFocus = () => {
  const { otaMachineRef } = useGlobalAppState();
  const { helpers } = useOtaMachine({ actorRef: otaMachineRef });

  useSafeFocusEffect(helpers.applyUpdate);
};
